<template>
  <div class="stepper">
    <div class="stepper__inner">
      <button
        class="stepper__button"
        :disabled="disableDecrement"
        @click="decreaseCount"
      >
        <i class="icon icon-stepper-minus" />
      </button>
      <span class="count">{{ count }}</span>
      <button
        class="stepper__button"
        :disabled="disableIncrement"
        @click="increaseCount"
      >
        <i class="icon icon-stepper-plus" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NumberStepper",
  props: {
    count: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
      default: null,
    },
  },
  emits: ["change"],
  computed: {
    disableIncrement() {
      if (this.max) {
        return !(this.max && this.count < this.max);
      }
      return false;
    },
    disableDecrement() {
      return !(this.count > 1);
    },
  },
  methods: {
    decreaseCount() {
      if (!this.disableDecrement) {
        this.$emit("change", this.count - 1);
      }
    },
    increaseCount() {
      if (!this.disableIncrement) {
        this.$emit("change", this.count + 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.stepper {
  display: inline-block;
  border-radius: 2px;
  border: 1px solid $color-grey;
  overflow: hidden;

  &__inner {
    display: flex;
    align-items: stretch;
    gap: 1px;
    background-color: $color-grey;
  }

  &__button,
  .count {
    height: 32px;
    min-width: 32px;
    width: auto;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  &__button {
    @include utility-label(13px);
    text-align: center;
    background: $color-white;
    outline: none;
    border: none;
    padding: 0;

    &:disabled {
      cursor: not-allowed;
      color: $color-grey;
    }
  }

  .count {
    padding: 0 4px;
    background: $color-white;
    @include utility-label(13px);
  }
}
</style>
